import React from "react";
import { RoleLayoutProps } from "./interface";

const RoleLayout: React.FC<RoleLayoutProps> = ({
  onClear,
  tabs,
  activeTabId
}) => {

  return (
    <div className="custom-tabs">
      <ul className="nav nav-tabs mb-3" role="tablist">
        {tabs.map((tab, index) => (
          <li className="nav-item" role="presentation" key={tab.id}>
            <button
              className={`nav-link ${activeTabId === tab.id ? "active" : ""}`}
              id={`${tab.id}-tab`}
              data-bs-toggle="pill"
              data-bs-target={`#${tab.target}`}
              type="button"
              role="tab"
              aria-controls={tab.target}
              aria-selected={index === 0}
              onClick={()=>onClear(tab.id)}
            >
              {tab.label}
            </button>
          </li>
        ))}
      </ul>

      <div className="tab-content">
        {tabs.map((tab, index) => (
          <div
            key={tab.target}
            className={`tab-pane fade ${activeTabId === tab.id ? "show active" : ""}`}
            id={tab.target}
            role="tabpanel"
            aria-labelledby={`${tab.id}-tab`}
            tabIndex={index}
            style={{ border: "#fff" }}
          >
            {tab.Content}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RoleLayout
